import { ErrorMessage, FieldInputProps, FieldMetaProps, FormikContextType, useField, useFormikContext } from 'formik';
import * as React from 'react';

//FYI: we are re-using the Field component pattern, but changing the "onChange" signature so it is compatible with Spruce Inputs
export interface IWrappedField<T = any> extends Omit<FieldInputProps<T>, 'onChange'> {
  onChange: (value: T | null) => void;
  errorText: React.ReactNode | null;
}

//FYI: This is the prop interface that you expect to use in a <SpruceField ...>{(field) => <AnySpruceInput {...field}/>}</SpruceField>
export interface ISpruceFieldProps<T = any> {
  field: IWrappedField<T>;
  formik: FormikContextType<any>;
  meta: FieldMetaProps<T>;
}

//TODO: rename this to ISpruceFieldProps for consistency and rename the old ISpruceFieldProps to ISpruceField
export interface ISpruceField {
  name: string;
  inputType?: 'select' | 'default';
  onChange?: (value: any) => void;
  children?: React.ReactNode | ((fieldProps: ISpruceFieldProps) => React.ReactNode) | any;
}

/** @Deprecated "Please use TextField, NumberField, SelectField where it is appropriate. Add new Fields to ui-toolkit when it is appropriate." */
export const SpruceField: React.FC<ISpruceField> = ({ children, inputType, ...props }) => {
  const formik = useFormikContext();
  const [field, meta] = useField(props);
  const wrappedField: IWrappedField = {
    ...field,
    // TODO: update to latest formik with helpers to remove "formik.setFieldValue first parameter as never" bug
    onChange: (value: any) => {
      // using any as a first pass.
      formik.setFieldTouched(field.name as never);
      // TODO: move this `inputType === 'select'` condition to SelectField when it's made. keep this onChange simple and let SelectField unwrap `value.value`
      if (inputType === 'select') {
        formik.setFieldValue(field.name as never, value ? value.value : undefined);
      } else {
        formik.setFieldValue(field.name as never, value);
      }
      if (props.onChange) {
        props.onChange(value);
      }
    },
    errorText: formik.touched[field.name] && formik.errors[field.name] ? <ErrorMessage name={field.name} /> : null,
  };
  return typeof children === 'function' ? children({ field: wrappedField, formik, meta }) : null;
};
